import Container from '@mui/material/Container';
import '../App.css';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ItemTodo from './ItemTodo';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useState,useContext,useEffect,useMemo } from 'react';



import { TodosContext } from '../contexts/TodoContext';

// dialog
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

// toast
import { TostContext } from '../contexts/TostContext';

export default function TodoBody() {
  const {showHideToastAlert} =useContext(TostContext);
  const [value, setValue] = useState(0);
  const [showDelete, setShowDelete] = useState(false);
  const [todoId,setTodoId]=useState("");

  const {todoList,dispatch}=useContext(TodosContext)
  const [todo,setTodo]=useState({
    id:null,
    title:"",
    content:"",
    isCompleted:false,
  }
); 
  const [open,setOpen]=useState(false);
  const [inputContent,setInputContent] =useState({
      title:"",
      content:""
  })

  // Start HANDLER //////////////////////////////
  const handleChange = (e, newValue) => {
    setValue(newValue);
  };

  const addingTodo =(e)=>{
    setTodo({...todo,title:e.target.value});
  };


  useEffect(()=>{
    dispatch({type:"get"})
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const showTodoList =(e)=>{
    e.preventDefault();
    dispatch({type:"added",payload:{title:todo.title}})
    
    setTodo({id:null,title:'',content:'',isCompleted:false});
    showHideToastAlert("تم الاضافة بنجاح")
  };
  
  //filteration of todos list
  const filteredTodos = useMemo(()=>{
    return todoList.filter(todo=>{
      if(value === 1){
        return todo.isCompleted;
      }else if(value === 2){
        return todo.isCompleted===false;
      }else{
        return true;
      }
    })
  },[todoList, value]);

  // show deleted dialog
  function showDeletedDialog(){
    setShowDelete(true)
  }
  // closing the message which asking about deleting
  const closeDeletedMessage = () => {
      setShowDelete(false)
  };
  //delete the selected item
  const deletedThisTodo =()=>{
      dispatch({type:"deleted",payload:{id:todoId}})
      setShowDelete(false);
      showHideToastAlert("تم الحذف بنجاح")
  };
  ////////////////////////////////end deleted///////////
  // start Edit todo item
    const handleEditClose = ()=>{
        setOpen(false);
    };
    function ShowEditDialog(){
      const selectedTodo= todoList.find((t)=>{
        return t.id=== todoId;
      })
      if(!selectedTodo) return;
      setInputContent({
        title:selectedTodo.title,
        content:selectedTodo.content
      })
      setOpen(true)
    }
    const handlerTitleInput =(e)=>{
        setInputContent({...inputContent,title:e.target.value});
    };
    const handlerContentInput =(e)=>{
        setInputContent({...inputContent,content:e.target.value});
    };
    const handleSubmitEditing =(e)=>{
        e.preventDefault();
        dispatch({type:"edit",payload:{id:todoId,title:inputContent.title,content:inputContent.content}})
        setOpen(false)
        showHideToastAlert("تم التعديل و الحفظ بنجاح")
    };

  
  return (
    <>
       {/* start dialog pop up for deleting */}
        <Dialog
        open={showDelete}
        onClose={closeDeletedMessage}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        >
            <DialogTitle id="alert-dialog-title"  sx={{ fontSize: '28px', textAlign: 'center' }}>
            {" هل  تريد حذف هذه المهمة ؟"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description" sx={{ fontSize: '22px', textAlign: 'center' }}>
                    عند الحذف لا يمكن ارجاع المهمة مرة اخري .
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'space-around', padding: 2 }} >
                <Button onClick={deletedThisTodo} sx={{backgroundColor:'#f00',fontSize:'24px',borderRadius:"8px",color:'#fff',width:'120px'}}>نعم,احذف</Button>
                <Button onClick={closeDeletedMessage}autoFocus sx={{backgroundColor:'#00f',fontSize:'24px',borderRadius:"8px",color:'#fff',width:'120px'}}>
                    اغلاق
                </Button>
            </DialogActions>
        </Dialog>
        {/* end dialog pop up for deleting */}
          {/* start edit dialog */}
        <Dialog open={open} onClose={handleEditClose} fullWidth>
            <DialogTitle style={{fontSize:'24px',fontWeight:'bold',textAlign:'center'}}>تعديل تفاصيل المهمة</DialogTitle>
            <DialogContent>
                <DialogContentText style={{margin:'5px 0 10px 0',fontSize:'20px',textAlign:'center'}}>
                    اكتب هنا تفاصيل المهمة التى تريد تعديلها
                </DialogContentText>
                <form onSubmit={handleSubmitEditing} id="subscription-form" >
                    <TextField
                    id="outlined-multiline-flexible"
                    label="العنوان"
                    multiline
                    fullWidth
                    style={{marginBottom:'10px'}}
                    value={inputContent.title} 
                    onChange={handlerTitleInput}         
                    />
                    <TextField
                    id="outlined-textarea"
                    label="المحتوي"
                    placeholder="المحتوي"
                    multiline
                    fullWidth
                    value={inputContent.content}
                    onChange={handlerContentInput}
                    />
                </form>
            </DialogContent>
            <DialogActions style={{display:'flex', justifyContent:'space-around'}}>
                <Button onClick={handleEditClose} 
                style={{
                    fontSize:'24px',
                    backgroundColor:"rgb(150, 43, 43)",
                    color:'#fff',
                    width:'100px'
                }}>
                اغلاق 
                </Button>
                <Button type="submit" form="subscription-form"
                    style={{
                    fontSize:'24px',
                    backgroundColor:"#18DE2A",
                    color:'#fff',
                    width:'100px'
                }}
                >
                    اضافة
                </Button>
            </DialogActions>
        </Dialog>
        {/* End edit dialog ////////////////////////////////////////// */}

        {/* start main content */}
      <Container maxWidth="md" className='todos-body'>
        <h2 style={{fontSize:"32px",margin:'10px', textAlign:'center'}}>قائمة المهام </h2>
        <hr></hr>
        {/* tabs of filtering */}
        <Box sx={{ width: '100%', bgcolor: 'background.paper',marginBottom:'20px' }}>
          <Tabs  value={value} onChange={handleChange} centered>
            <Tab style={{fontSize:'24px'}} label="الكل"  />
            <Tab style={{fontSize:'24px'}} label=" منجز"  />
            <Tab style={{fontSize:'24px'}} label="غير منجز "  />
          </Tabs>
        </Box>
        {/* tabs of filtering =================*/}
        {/* items of todos */}
        {
          filteredTodos.map(t=>{
            return <ItemTodo key={t.id}
            idParam={t.id}
            title ={t.title} 
            content={t.content} 
            completed={t.isCompleted} 
            onDelete={()=>{
            setTodoId(t.id)
            showDeletedDialog()}}
            onEdit={()=>{
              setTodoId(t.id)
              ShowEditDialog()
            }}
          />
          })
        }
        {/* items of todos ===================== */}
        {/* adding a new todo item */}
        <Box
        style={{
          width:'100%',
          display:'flex',
          justifyContent:'center',
          marginTop:'20px'
        }}
          component="form"
          autoComplete="off"
        >
          <TextField id="outlined-basic" value={todo.title} onChange={addingTodo} label="عنوان المهمة" variant="outlined" fullWidth/>
          <Button 
            variant="contained" 
            onClick={showTodoList}
              style={{width:'30%',marginRight:'20px',fontSize:'24px'}}
              disabled={todo.title.length === 0}
              >
              اضافة</Button>
        </Box>
        {/* adding a new todo item ==============*/}
      </Container>
    </>
  );
}